import { get, head } from 'lodash';
import moment from 'moment';
import endpoints from '../../utils/endpoints';
import { apiDateFormat, TYPE_IFT } from '../../config';
import { mapAuthorisersGroup } from '../../utils/authoriserUtils';
import { getApproversPayload } from '../../helpers/apiRequestBuilder/common';

const formatDate = (date) => moment(date).format(apiDateFormat);

const getAmount = (payment) => {
	const paymentAmounts = get(payment, 'rates.details[0].payment_amount', []);
	const gbpPayment = paymentAmounts.find((amount) => amount.currency === 'GBP');
	const value = get(gbpPayment, 'value');
	return {
		amount: {
			value,
			currency: 'GBP',
		},
	};
};

export const getIFTPaymentReviewRequest = (bankId) => (payment, isFromKapitiAccount) => {
	const endpoint = isFromKapitiAccount ? endpoints.authoriseKapitiInternationalPayment : endpoints.authorisation;
	const uri = endpoint.resolve(bankId, 'default');
	const { x_bpi_version, method } = endpoint;
	const date = moment.isMoment(payment.date) ? formatDate(payment.date) : '';

	return {
		id: payment.id,
		method,
		uri,
		x_bpi_version,
		body: {
			source_id: payment.id,
			account_ids: [payment.fromAccount],
			payment_date: date,
			beneficiary_id: get(payment, 'toAccount'),
			...getAmount(payment),
			payment_category: TYPE_IFT,
		},
	};
};

export const getIFTPaymentConfirmedRequest = (bankId) => (payment) => {
	const uri = endpoints.createInternationalPayment.resolve(bankId, 'default', payment.fromAccount);
	const { x_bpi_version, method } = endpoints.authorisation;
	const details = head(get(payment, 'rates.details'));
	const namedApprovers = { approver_id: get(payment, 'authorisers', []).map((authoriser) => authoriser.id) };
	const authorisersGroup = get(payment, 'authorisersGroup', []);
	const mappedAuthorisersGroup = mapAuthorisersGroup(authorisersGroup);
	const groupApprovers = { approval_group_approver_id: mappedAuthorisersGroup };
	const approversPayload = getApproversPayload(namedApprovers, groupApprovers);
	const body = {
		source_id: payment.id,
		beneficiary_id: payment.toAccount,
		send_currency: payment.sendCurrency,
		payment_amount: details.payment_amount,
		exchange_rate: {
			rate: get(payment, 'rates.fx.rate'),
			type: get(payment, 'rates.fx.type'),
		},
		...(payment.preBookedReference && { deal_reference: payment.preBookedReference }),
		charging_model: payment.chargingModal,
		charge_amount: get(details, 'charge_amount'),
		submission_date: details.submission_date,
		value_date: details.value_date,
		reference: payment.reason,
		urgent: payment.urgent,
		update_beneficiary_currency: payment.isDefaultCurrency,
		...(!!approversPayload && approversPayload),
		pei_id: details.pei_id,
		pei_bulk_id: get(payment, 'rates.pei_bulk_id'),
		payment_method: details.payment_method,
		value_date_type: details.value_date_type,
	};

	return {
		id: payment.id,
		method,
		uri,
		x_bpi_version,
		body,
	};
};

export const getIFTEditPaymentRequest = (payment) => {
	const details = head(get(payment, 'rates.details'));
	const approver_id = get(payment, 'authorisers', []).map((authoriser) => authoriser.id);
	return {
		source_id: payment.id,
		beneficiary_id: payment.toAccount,
		send_currency: payment.sendCurrency,
		payment_amount: details.payment_amount,
		exchange_rate: {
			rate: get(payment, 'rates.fx.rate'),
			type: get(payment, 'rates.fx.type'),
		},
		...(payment.preBookedReference && { deal_reference: payment.preBookedReference }),
		charging_model: payment.chargingModal,
		charge_amount: get(details, 'charge_amount'),
		submission_date: details.submission_date,
		value_date: details.value_date,
		reference: payment.reason,
		urgent: payment.urgent,
		approver_id,
		update_beneficiary_currency: payment.isDefaultCurrency,
		pei_id: details.pei_id,
		pei_bulk_id: get(payment, 'rates.pei_bulk_id'),
		payment_method: details.payment_method,
		value_date_type: details.value_date_type,
	};
};
